import {Alert, Breadcrumb, Button} from "antd";
import {Link, useSearchParams} from "react-router-dom";
import {SessionFormsPrototype} from "./prototype";
import {DashboardWrapper} from "../../../../layouts/dashboard-wrapper";
import {StyledPageWrapper} from "../../../../styles/dashboard/calls/calls";
import {CanvaTemplateWidget} from "../../../../components/widgets/canva-template-widget";
import {ErrorBoundary} from "react-error-boundary";
import {CreateSessionMultiStepFormWrapper} from "../../../../calls/useCases/createService/multi-step/multi-step-form-wrapper";
import {StyledHideStepsOnMobile} from "../../../../components/offering-form/general/steps/styles";
import {CreateSessionContextWrapper} from "../../../../calls/useCases/createService/context/create-session/context-wrapper";
import {CreateSessionFormSteps} from "../../../../calls/useCases/createService/create-session-steps";

const AddCallPage = () => {
  const [searchParams] = useSearchParams();

  // PROTOTYPE: `?variant=A|B|C` swaps the real form for the throwaway clickthrough.
  // No param, or the production environment, gets the real page unchanged. Gated on
  // REACT_APP_APP_ENV rather than NODE_ENV so it shows on staging, which is also a
  // `yarn build` and so always has NODE_ENV=production.
  if (searchParams.get("variant") && process.env.REACT_APP_APP_ENV !== "production") {
    return (
      <DashboardWrapper pageTitle="Create a new 1:1 session">
        <SessionFormsPrototype />
      </DashboardWrapper>
    );
  }

  return (
    <DashboardWrapper pageTitle="Create a new 1:1 session">
      <CreateSessionContextWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/calls">1:1 Sessions</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Create a new 1:1 session</Breadcrumb.Item>
        </Breadcrumb>
        <StyledPageWrapper>
          <div className="main-area">
            <ErrorBoundary
              FallbackComponent={({error, resetErrorBoundary}) => (
                <div>
                  <Alert
                    message="Sorry, something went wrong."
                    showIcon
                    description={error.message}
                    type="error"
                    action={
                      <Button
                        onClick={() => {
                          resetErrorBoundary();
                        }}
                        size="small"
                        danger
                      >
                        Reset
                      </Button>
                    }
                  />
                </div>
              )}
            >
              <CreateSessionMultiStepFormWrapper />
            </ErrorBoundary>
          </div>
          <div className="widget-area">
            <StyledHideStepsOnMobile>
              <CreateSessionFormSteps />
            </StyledHideStepsOnMobile>
            <CanvaTemplateWidget url="https://www.canva.com/design/DAGOSXnkoPE/5Fg__pLqNu6jl-cliuexgQ/view?utm_content=DAGOSXnkoPE&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview" />
          </div>
        </StyledPageWrapper>
      </CreateSessionContextWrapper>
    </DashboardWrapper>
  );
};

export {AddCallPage};
